const initialState = {
    instanceID: null,
    frontSubmitted: false,
    backSubmitted: false,
    faceMatch: null,
    result: null,
    cardType: 1,
    orientation: 0,
    sidesLeft: 2,
    error: null
};

export default function appReducer(state = initialState, action) {
    switch (action.type) {
        // app reducer
        case "ADD_INSTANCE_ID":
            return {
                ...state,
                instanceID: action.payload,
                faceMatch: "",
                resultData: null
            };
        case "ADD_FACE_MATCH":
            return {
                ...state,
                instanceID: state.instanceID,
                faceMatch: action.payload,
                resultData: state.resultData
            };
        case "ADD_RESULT_DATA":
            return {
                ...state,
                instanceID: state.instanceID,
                faceMatch: state.faceMatch,
                resultData: action.payload
            };
        case "ADD_REDIRECT":
            return {
                ...state,
                instanceID: state.instanceID,
                faceMatch: "",
                resultData: null,
                redirect: action.payload,
            };

        // processed data reducer
        case "@@acuant/ADD_ID_RESULT_DATA":
            return {
                ...state,
                result: action.payload
            };
        case "@@acuant/ADD_FACE_MATCH_DATA":
            return {
                ...state,
                faceMatch: action.payload
            };
        case "@@acuant/RESET_PROCESSED_DATA":
            return {
                ...state,
                faceMatch: null,
                result: null
            };

        // ID properties reducer
        case "@@acuant/SET_ID_TYPE":
            return {
                ...state,
                cardType: action.data
            };
        case "@@acuant/SET_ORIENTATION":
            return {
                ...state,
                orientation: action.data
            };
        case "@@acuant/DECREMENT_SIDE": {
            let sidesLeft = state.sidesLeft;
            return {
                ...state,
                sidesLeft: sidesLeft - 1
            }
        }
        case "@@acuant/INCREMENT_SIDE": {
            let sidesLeft = state.sidesLeft;
            return {
                ...state,
                sidesLeft: sidesLeft + 1
            }
        }
        case "@@acuant/RESET_ID": {
            return {
                ...state,
                // cardType: 1,
                orientation: 0,
                sidesLeft: 2
            }
        }

        // config reducer
        case '@@acuant/SET_INSTANCE_ID':
            return {
                ...state,
                instanceID: action.data
            };
        case '@@acuant/FRONT_ID_SUBMITTED':
            return {
                ...state,
                frontSubmitted: true
            }
        case '@@acuant/BACK_ID_SUBMITTED':
            return {
                ...state,
                backSubmitted: true
            }
        case '@@acuant/RESET_CONFIG':
            return {
                ...state,
                instanceID: null,
                frontSubmitted: false,
                backSubmitted: false
            }
        default:
            return state;
    }
}